<a class="back-button" [routerLink]="backLink()">
  <span class="back-button__icon">
    <i class="icon icon-arrow-left"></i>
  </span>
  <span class="back-button__label">
    <ng-content />
  </span>
</a>
